// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.header[data-v-6513ebe4] {
  background-color: #f7fafc;
[data-v-6513ebe4] .van-search__content {
    background-color: transparent;
    padding-left: 0;
}
[data-v-6513ebe4] .van-field__left-icon {
    display: none;
}
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
